import $ from 'jquery';
import MarkerClusterer from 'components/markerclusterer';

// more button
let actualPage = 0;
$('#moreBtn').on('click', function () {
    actualPage++;
    $('.show-group-' + actualPage).show();
    if ($('.show-group-' + (actualPage + 1)).length === 0) {
        $(this).hide();
    }
});

window.initMap = () => {
    const map = new window.google.maps.Map(document.querySelector('#google-maps'), {
        center: { lng: 0, lat: 0 },
        zoom: 1
    });
    if (window.eventCoords.length > 0) {
        const markers = [];
        for (let coord of window.eventCoords) {
            markers.push(new window.google.maps.Marker({ position: coord, title: coord.title }));
        }
        map.setCenter({ lng: 9.132, lat: 47.568 });
        map.setZoom(9);
        new MarkerClusterer(map, markers, {
            imagePath: GLOBALS.customer_webroot + '/frontend/static/graphics/cluster'
        });
    }
};
